import React from 'react';
import type { RouteObject } from 'react-router-dom';

const ExplorePage = React.lazy(() => import('@/pages/explore'));
const SearchPage = React.lazy(() => import('@/pages/search'));
const WeatherPage = React.lazy(() => import('@/pages/weather'));

export const exploreRoutes: RouteObject[] = [
  {
    path: 'explore',
    element: <ExplorePage />,
  },
  {
    path: 'search',
    element: <SearchPage />,
  },
  {
    path: 'weather',
    element: <WeatherPage />,
  },
];
